/**
 * Головна сторінка салону краси
 * @component HomePage
 * @file HomePage.tsx
 * @path frontend/src/pages/HomePage.tsx
 */

import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAuth } from '../../contexts/AuthContext';
import RegisterModal from '../../modals/RegisterModal';
import LoginModal from '../../modals/LoginModal';
import './style.css';

const HomePage: React.FC = () => {
  const { language } = useLanguage();
  const { isAuthenticated, user } = useAuth();
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [showHeroSection, setShowHeroSection] = useState(true);

  // Перевіряємо, чи це перший вхід користувача
  useEffect(() => {
    if (isAuthenticated && user) {
      const hasSeenHero = localStorage.getItem(`hero_seen_${user.id}`);
      if (hasSeenHero) {
        // Користувач вже бачив лейаут при попередньому вході
        setShowHeroSection(false);
      } else {
        // Це перший вхід - показуємо лейаут та зберігаємо цей факт
        localStorage.setItem(`hero_seen_${user.id}`, 'true');
        setShowHeroSection(true);
      }
    }
  }, [isAuthenticated, user]);

  const openRegisterModal = () => {
    setIsRegisterModalOpen(true);
  };

  const closeRegisterModal = () => {
    setIsRegisterModalOpen(false);
  };

  const openLoginModal = () => {
    setIsLoginModalOpen(true);
  };

  const closeLoginModal = () => {
    setIsLoginModalOpen(false);
  };

  return (
    <>
      {showHeroSection && (
        <div className="hero-layout">
          <div className="container">
            <div className="hero-section">
              <button 
                className="hero-close-btn"
                onClick={() => setShowHeroSection(false)}
                title={language === 'ua' ? 'Закрити' : 'Close'}
              >
                <i className="bi bi-x"></i>
              </button>
              
              {/* <h1 className="page-title">
                {language === 'ua' 
                  ? 'Ласкаво просимо до платформи OnVisit' 
                  : 'Welcome to OnVisit Platform'
                }
              </h1> */}
              
              <p className="hero-description">
                {language === 'ua'
                  ? 'Професійна система управління салонами краси, записами клієнтів та послугами'
                  : 'Professional beauty salon management system for clients, appointments and services'
                }
              </p>

              {!isAuthenticated ? (
                <div className="auth-buttons">
                  <button 
                    className="primary-button"
                    onClick={openRegisterModal}
                  >
                    <i className="bi bi-person-plus"></i>
                    {language === 'ua' ? 'Зареєструватися' : 'Sign Up'}
                  </button>
                  
                  <button className="secondary-button" onClick={openLoginModal}>
                    <i className="bi bi-box-arrow-in-right"></i>
                    {language === 'ua' ? 'Увійти' : 'Sign In'}
                  </button>
                </div>
              ) : (
                <div className="welcome-back">
                  {/* <h2>
                    {language === 'ua' 
                      ? `Вітаємо, ${user?.first_name}!`
                      : `Welcome back, ${user?.first_name}!`
                    }
                  </h2> */}
                  <p>
                    {language === 'ua'
                      ? `Ваша роль: ${user?.role}`
                      : `Your role: ${user?.role}`
                    }
                  </p>
                </div>
              )}
            </div>

            <div className="features-section">
              <h2>
                {language === 'ua' ? 'Можливості платформи' : 'Platform Features'}
              </h2>
              
              <div className="features-grid">
                <div className="feature-card">
                  <i className="bi bi-calendar-check"></i>
                  <h3>
                    {language === 'ua' ? 'Запис клієнтів' : 'Client Appointments'}
                  </h3>
                  <p>
                    {language === 'ua'
                      ? 'Зручна система запису та управління розкладом'
                      : 'Convenient booking and schedule management system'
                    }
                  </p>
                </div>

                <div className="feature-card">
                  <i className="bi bi-person-workspace"></i>
                  <h3>
                    {language === 'ua' ? 'Управління майстрами' : 'Master Management'}
                  </h3>
                  <p>
                    {language === 'ua'
                      ? 'Керування командою майстрів та їх спеціалізаціями'
                      : 'Manage your team of masters and their specializations'
                    }
                  </p>
                </div>

                <div className="feature-card">
                  <i className="bi bi-shop"></i>
                  <h3>
                    {language === 'ua' ? 'Мережа салонів' : 'Salon Network'}
                  </h3>
                  <p>
                    {language === 'ua'
                      ? 'Управління кількома локаціями з єдиної платформи'
                      : 'Manage multiple locations from a single platform'
                    }
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Модальне вікно реєстрації */}
      <RegisterModal 
        isOpen={isRegisterModalOpen}
        onClose={closeRegisterModal}
        onOpenLogin={() => {
          console.log('RegisterModal: onOpenLogin called');
          setIsRegisterModalOpen(false);
          setIsLoginModalOpen(true);
        }}
      />

      {/* Модальне вікно входу */}
      <LoginModal 
        isOpen={isLoginModalOpen}
        onClose={closeLoginModal}
      />
    </>
  );
};

export default HomePage;